import { CustomModal } from "components";
import { useRef, useState } from "react";
import { jsPDF } from "jspdf";
import { Button } from "reactstrap";

const usePDF = (component, PDFName = "exported_pdf.pdf") => {
	const componentRef = useRef(null);
	const [exporting, setExporting] = useState(false);
	const [show, setShow] = useState(false);

	const exportPDF = () => {
		if (!componentRef.current) return;
		setExporting(true);
		const pdf = new jsPDF({ orientation: "p", unit: "px", format: "a4", hotfixes: ["px_scaling"] });
		pdf.html(componentRef.current)
			.then(() => pdf.save(PDFName))
			.finally(() => setExporting(false));
	};

	const showModal = () => setShow(true);

	const hideModal = () => setShow(false);

	const PDF = () => (
		<CustomModal
			show={show}
			hideModal={hideModal}
			zIndex={50}
			compact={true}
			buttons={
				<Button color="success" onClick={exportPDF} disabled={exporting}>
					Download
				</Button>
			}
		>
			<div className="d-flex justify-content-center pb-3" style={{ width: "100%" }}>
				<div ref={componentRef} style={{ backgroundColor: "white", maxWidth: 21 * 37.8, width: 21 * 37.8 }}>
					{component}
				</div>
			</div>
		</CustomModal>
	);

	return [PDF, showModal, exportPDF, exporting];
};

export default usePDF;
